var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AbortController } from 'node-abort-controller';
/**
 * Creates a signal using the {@see AbortController} that aborts after
 * the specified time passes.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/AbortController
 */
const withTimeoutSignal = (timeout, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try {
        const result = yield callback(controller.signal);
        clearTimeout(timer);
        return result;
    }
    catch (error) {
        clearTimeout(timer);
        throw error;
    }
});
export default withTimeoutSignal;
